import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import cx from "classnames";
import { addNotification } from "root/actions";
import notifications, { NOTIFICATION_IDS } from "root/data/NotificationsData";
import { consts as uploaderConsts } from "uploader/index";
import TabPanel from "tabs/hocs/TabPanel";
import ServiceLoginIntro from "root/components/ServiceLoginIntro";
import t from "common/i18n";
import rootActions, { types as rootAts } from "root/actions";
import TabProgress from "root/components/Progress/TabProgress";
import appConfig from "appConfig";
import { getInternalPath } from "./utils";
import actions, { types as ats } from "./actions";
import { useAuth, useIStockServer, useCloudName, useNewTlsDomain } from "./selectors";
import AuthContent from "./components/AuthContent";
import getIStockService from "./service";
import Footer from "./components/Footer";
import SVG_ICONS from "~/assets/icons/icons";

const introFooter = () => (
	<a className="c-link" href={appConfig.iStock.registrationLink} target="_blank" rel="noopener noreferrer">
		{t("istock.reg_link_text")}
	</a>
);

const { [rootAts.ADD_UPLOAD_TO_QUEUE]: handleUploadAssetAction } = rootActions.creators;

const {
	[ats.DO_LOGIN]: handleLoginAction,
	[ats.TOGGLE_FILTERS_PANEL]: handleTogglePanelAction,
	[ats.PURCHASE]: handlePurchaseAssetAction,
} = actions.creators;

export const LoginIntro = ({ handleLoginAction }) => {
	const { isAuthInProgress } = useAuth();
	const cloudName = useCloudName();
	const server = useIStockServer();
	const newTlsDomain = useNewTlsDomain();
	const dispatch = useDispatch();
	const history = useHistory();

	const onNoAuthActionClick = useCallback(() => {
		getIStockService().openAuthWindow({
			cloudName,
			server,
			newTlsDomain
		});
	}, [cloudName, server, newTlsDomain]);

	useEffect(() => {
		getIStockService().setAuthListener(cloudName).then(result => {
			dispatch(handleLoginAction({ token: result }));
			const path = getInternalPath();
			if (history.location.pathname !== path) {
				history.push(path);
			}
		}).catch(() => {
			addNotification(notifications[NOTIFICATION_IDS.ERROR], dispatch);
		});
	}, [dispatch, cloudName, handleLoginAction, history]);

	return (
		<>
			<ServiceLoginIntro
				key="istock_login_intro"
				title={t("istock.no_auth_title")}
				actionTitle={t("istock.no_auth_action")}
				statement={t("istock.no_auth_statement")}
				btnIcon={SVG_ICONS.ISTOCK}
				btnClass="btn-drive"
				actionHandler={onNoAuthActionClick}
				footer={introFooter()}
			/>
			{isAuthInProgress && <TabProgress />}
		</>
	);
};

export const IStockTab = ({ routes }) => {
	const { isSignedIn } = useAuth();
	const dispatch = useDispatch();

	const handleTogglePanel = useCallback(() => {
		dispatch(handleTogglePanelAction());
	}, [dispatch]);

	const handleUploadAsset = useCallback((payload) => {
		dispatch(handleUploadAssetAction(payload));
	}, [dispatch]);

	const handlePurchaseAsset = useCallback(() => {
		dispatch(handlePurchaseAssetAction());
	}, [dispatch]);
	return (
		<div className={cx("content-wrap bg-source-bg bg-source-bg-c istock-block", {
			"user-active": isSignedIn,
		})}>
			{!isSignedIn && (
				<div className="holder large-thin-menu-holder ">
					<LoginIntro handleLoginAction={handleLoginAction} />
				</div>
			)}
			{isSignedIn && <AuthContent routes={routes} />}
			<Footer togglePanel={handleTogglePanel} uploadAsset={handleUploadAsset} purchaseAsset={handlePurchaseAsset}/>
		</div>
	);
};

export default TabPanel({
	id: uploaderConsts.SOURCES.ISTOCK,
})(IStockTab);
